var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-main has-bottom" },
        [
          _c("page-title", {
            attrs: { back: true },
            on: { goback: _vm.goback },
          }),
          _vm._v(" "),
          _c(
            "page-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { "margin-bottom": "32px" },
            },
            [
              _c("template", { slot: "header" }, [
                _vm._v(" Well Information "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("wellComp", {
                    attrs: { "page-data": _vm.pageData, "well-index": 1 },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "page-bottom",
        [
          [
            _c(
              "div",
              { staticClass: "page-btns" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.handleReject()
                      },
                    },
                  },
                  [_vm._v("Reject")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.handleApproval()
                      },
                    },
                  },
                  [_vm._v("Approval")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _vm._v(" "),
      _c("editInformationSuccess", {
        ref: "editInformationSuccess",
        attrs: { "no-tip": true, msg: "Approved completed!" },
        on: { close: _vm.goback },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: _vm.title, visible: _vm.open, width: "6rem" },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "p",
            { staticClass: "des" },
            [
              _c("svg-icon", { attrs: { "icon-class": "warning" } }),
              _vm._v(
                "   Are you sure to " +
                  _vm._s(_vm.title.toLowerCase()) +
                  " the\n      application?\n    "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.title === "Reject"
            ? _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-position": "top" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Approval Instructions",
                        prop: "refusalReason",
                        rules: [
                          {
                            required: true,
                            message: "Plase fill in",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", autocomplete: "off" },
                        model: {
                          value: _vm.form.refusalReason,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "refusalReason", $$v)
                          },
                          expression: "form.refusalReason",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("Cancel"),
              ]),
              _vm._v(" "),
              _c("loading-btn", {
                attrs: { type: "primary", label: "Confirm" },
                on: {
                  clickHandle: function ($event) {
                    return _vm.handleEvent($event, 3)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }